export const DEFAULT_BREADCRUMB_LEVEL = 'info';
//# sourceMappingURL=breadcrumb.js.map